// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CampaignList_wrapper__uhCni","titleWrapper":"CampaignList_titleWrapper__vk42q","title":"CampaignList_title__OgiMU","select":"CampaignList_select__xQN6B"};